module.exports = __webpack_public_path__ + "static/img/公司12.8b3bbc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司12.jpg
// module id = rdv3
// module chunks = 1